import { standardProfile } from "./standard-dealer";

const stockColumnOrder = [
    "SKU",
    "description",
    "avaibleQuantity",
    "reservedQuantity",
    "serialCode",
    "amount",
    "SORD",
    "BCNU",
    "SCNU",
    "ownerCode",
    "CNUM",
    "dealerName",
    "dealerCode"
];

const stockFilterOrder = [
    "SKU",
    "description",
    "amount",
    "QuantityFilter",
    "DELN",
    "SORD",
    "dealerCode",
    "SCNU",
    "SCNA",
    "CNUM",
    "serialCode",
    "filterButton",
    "clearButton"
];

export const npoProfile = {
    ...standardProfile,

    code: "NPO",

    orderCreation: {
        ...standardProfile.orderCreation,

        components: {
            ...standardProfile.orderCreation.components,

            filters: {
                ...standardProfile.orderCreation.components.filters,

                props: {
                    ...standardProfile.orderCreation.components.filters.props,
                    order: stockFilterOrder
                }
            },

            stockTable: {
                ...standardProfile.orderCreation.components.stockTable,

                props: {
                    ...standardProfile.orderCreation.components.stockTable.props,

                    columnOrder: stockColumnOrder
                }
            }
        }
    },

    stock: {
        ...standardProfile.stock,

        components: {
            ...standardProfile.stock.components,

            filters: {
                ...standardProfile.stock.components.filters,

                props: {
                    ...standardProfile.stock.components.filters.props,

                    order: stockFilterOrder
                }
            },

            table: {
                ...standardProfile.stock.components.table,

                props: {
                    ...standardProfile.stock.components.table.props,
                    columnOrder: stockColumnOrder
                }
            }
        }
    },

    orderHistory: {
        ...standardProfile.orderHistory,

        components: {
            ...standardProfile.orderHistory.components,

            details: {
                enabled: true,

                props: {
                    ...standardProfile.orderHistory.components.details.props,
                    showAmount: true
                }
            }
        }
    },

    customizeHeaders(headers) {
        return [
            ...headers,
            {
                label: "Amount",
                field: "amount",
                className: "cell-center",
                size: 2
            }
        ];
    },

    customizeFilters(filters) {
        const { filterButton, clearButton, ...fields } = filters;

        return {
            ...fields,

            //amount: {
            //    type: "text",
            //    width: "20%",
            //    label: "Amount"
            //},

            filterButton,
            clearButton
        };
    },

    customizeStockRequest(data, filters) {
        const amount = String(filters.amount ?? "").trim();

        if (!amount) {
            return data;
        }

        return {
            ...data,
            AMNT: amount
        };
    }
};